import { render, staticRenderFns } from "./TotWeekCellMeals.vue?vue&type=template&id=65ff3a26&scoped=true&"
import script from "./TotWeekCellMeals.vue?vue&type=script&lang=js&"
export * from "./TotWeekCellMeals.vue?vue&type=script&lang=js&"
import style0 from "./TotWeekCellMeals.vue?vue&type=style&index=0&id=65ff3a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff3a26",
  null
  
)

export default component.exports